import { useEffect, useState } from "react";
import { Button, Card } from "@mui/material";
import { handleAxiosError } from "app/services/app.error.handler";
import { loadAllActivityTypes, deleteActivityType } from "app/services/admin.service";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { Add as AddIcon } from "components/icons";

import { useDispatch, useSelector } from "react-redux";
import { Stack } from "@mui/system";
import { ConfirmDialog } from "../ConfirmDialog";
import AddActivityTypeDialog from "./AddActivityTypeDialog";
import { ActivityTypesDataGrid } from "./ActivityTypesDataGrid";
import { activityActions } from "store/activity-slice";

const AllActivityTypesView = () => {
  const dispatch = useDispatch();
  const [isLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [editObject, setEditObject] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [deleteId, setDeleteId] = useState(null);
  const activityTypes = useSelector((state) => state.activity.typeRows);

  const btnClickHandler = () => {
    loadAllActivityTypes()
      .then((response) => dispatch(activityActions.replaceTypeData(response.data)))
      .catch((error) => {
        dispatch(activityActions.replaceTypeData([]));
        handleAxiosError(error);
      });
  };

  useEffect(() => {
    if (activityTypes.length !== 0) return;
    btnClickHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activityTypes.length]);

  const editEventHandler = (data) => {
    setOpen(true);
    setEditObject(data);
  };

  const confirmDeleteDialogHandler = (data) => {
      setConfirmationMessage(
        `Are you sure you want to delete this Client Activity Type ('${
          data.activityDesc}' for '${data.client.code}')?`
      );

    const editObjectId = data.id;

    setDeleteId(editObjectId);
    setConfirmOpen(true);
  };

  const deleteHandler = async () => {
    await deleteActivityType(deleteId)
    .then((response) => {
      btnClickHandler();
    })
    .catch((error) => {
      handleAxiosError(error);
    });
  };

  return (
    <div
      className="content-container"
      style={{ width: "100%", minWidth: 0, padding: "0 16px", boxSizing: "border-box" }}
    >
      <Card>
        <MDBox
          mx={2}
          mt={-3}
          py={1}
          px={2}
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
        >
          <MDTypography variant="h6" color="white">
            Client Activity Types
          </MDTypography>
        </MDBox>
        <MDBox mt={1} px={2} py={0.5}>
          <Stack direction="row" spacing={2}>
            <MDBox>
              <Button
                startIcon={<AddIcon />}
                onClick={() => {
                  setEditObject(null);
                  setOpen(true);
                }}
                sx={{ minWidth: 180, m: 0 }}
                variant="contained"
                color="success"
              >
                Add Client Activity Type
              </Button>
            </MDBox>
          </Stack>
        </MDBox>
        <MDBox height={500} mb={0} sx={{ overflowX: "auto" }}>
          <ActivityTypesDataGrid activityTypes={activityTypes} isLoading={isLoading} editEventHandler={editEventHandler} confirmDeleteDialogHandler={confirmDeleteDialogHandler} />
        </MDBox>
      </Card>
      <AddActivityTypeDialog
        open={open}
        setOpen={setOpen}
        refreshActivitiesDataHandler={btnClickHandler}
        editObject={editObject}
      />
      <ConfirmDialog
        title={"Delete This Activity Type?"}
        open={confirmOpen}
        setOpen={setConfirmOpen}
        onConfirm={deleteHandler}
        yesButtonLabel="Delete"
        noButtonLabel="Cancel"
      >
        {confirmationMessage}
      </ConfirmDialog>
    </div>
  );
};

export default AllActivityTypesView;
